"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePropertyWatcher = changePropertyWatcher;

var _effects = require("redux-saga/effects");

var types = _interopRequireWildcard(require("./types"));

var actions = _interopRequireWildcard(require("./actions"));

var _data = require("../../../../constants/data");

var _actions2 = require("../../../data/value/actions");

var _selector = require("../../../data/value/selector");

var _apiRequest = require("../../api/apiRequest");

var _emailSettings = require("../../../../constants/emailSettings");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(changeProperty),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(changePropertyWatcher);

function changeProperty(action) {
  var _action$payload, index, typeId, partnerId, property, newValue, propertyType, state, emailSettings;

  return regeneratorRuntime.wrap(function changeProperty$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, index = _action$payload.index, typeId = _action$payload.typeId, partnerId = _action$payload.partnerId, property = _action$payload.property, newValue = _action$payload.newValue;
          _context.next = 3;
          return (0, _effects.put)(actions.request(index));

        case 3:
          _context.prev = 3;
          propertyType = _lodash["default"].findKey(_emailSettings.EMAIL_SETTINGS_PROPERTY_TYPE, function (item) {
            return item === property;
          });
          _context.next = 7;
          return (0, _effects.call)(_apiRequest.apiRequest, _data.DATA_URLS.EMAIL_SETTINGS_CHANGE_PROPERTY_URL, "POST", {
            body: {
              typeId: typeId,
              partnerId: partnerId,
              property: propertyType,
              value: newValue
            }
          });

        case 7:
          _context.next = 9;
          return (0, _effects.select)();

        case 9:
          state = _context.sent;
          emailSettings = (0, _selector.getValue)(state, _data.DATA_TYPE.EMAIL_SETTINGS);
          emailSettings.records[index][property] = newValue;
          _context.next = 14;
          return (0, _effects.put)((0, _actions2.setValue)(_data.DATA_TYPE.EMAIL_SETTINGS, emailSettings));

        case 14:
          _context.next = 16;
          return (0, _effects.put)(actions.success(index));

        case 16:
          _context.next = 23;
          break;

        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](3);
          console.error(_context.t0);
          _context.next = 23;
          return (0, _effects.put)(actions.failure(index));

        case 23:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 18]]);
}

function changePropertyWatcher() {
  return regeneratorRuntime.wrap(function changePropertyWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, changeProperty);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}